import React from 'react';

import BundleShowView from '@components/shared/bundles/BundleShowView';
import { useLoaderData } from 'react-router-dom';

const AdminBundleShow: React.FC = () => {
  // useLoaderData 回傳 unknown，由 router 的 loader 保證實際 shape；於此 narrow
  const bundle = useLoaderData() as React.ComponentProps<typeof BundleShowView>['bundle'];

  return (
    <BundleShowView
      bundle={bundle}
      role="admin"
    />
  );
};

export default AdminBundleShow;
